import { routes as coverEditor } from 'modules/coverEditor/routes';

const routes = [].concat(coverEditor);

export default routes;
